export default class CreateRouteData {
    constructor(companyId, routePoints, description, verified = false,) {
        this.companyId = companyId
        this.routePoints = routePoints
        this.description = description
        this.verified = verified
    }
}